module.exports = __webpack_public_path__ + "static/media/sell_take_order_make_2.5261aeeb.jpg";